import { render, staticRenderFns } from "./InstallTreat.vue?vue&type=template&id=6dbceeaa&scoped=true"
import script from "./InstallTreat.vue?vue&type=script&lang=js"
export * from "./InstallTreat.vue?vue&type=script&lang=js"
import style0 from "./InstallTreat.vue?vue&type=style&index=0&id=6dbceeaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbceeaa",
  null
  
)

export default component.exports